'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialGoogleplus = function IoSocialGoogleplus(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.4 21.6c1.7 1.4 3.5 2.8 3.5 5.7 0 3.8-3.7 7.7-10.8 7.7-6.3 0-9.1-3-9.1-6 0-0.8 0.2-3.3 3.3-5.1 2.1-1.2 4.7-1.6 6.6-1.8-0.3-0.5-0.6-1.2-0.6-2 0-0.3 0-0.6 0.1-0.8h-0.3c-1.5 0-3.6-0.3-5.3-2-1.1-1.2-1.8-2.8-1.8-4.5 0-2 1-4.1 2.7-5.5 2.5-2 5.4-2.3 7.3-2.3h10.5l-4.7 2.6h-1c0.9 1 1.8 2.4 1.8 4.5 0 3.1-2 4.6-3.5 5.8v0.1c-0.5 0.4-0.9 0.7-0.9 1.3 0 0.5 0.3 0.8 0.8 1.2z m-9.8-10.7c0 1.1 0.4 2.6 1.1 4 0.6 1 1.7 2.1 3.2 2.1 0.8 0 1.7-0.3 2.2-0.8 0.8-0.8 0.8-2 0.8-2.4 0-1.4-0.5-2.9-1.2-4.1-0.6-1-1.5-2.2-3.1-2.2-0.8 0-1.8 0.4-2.3 1-0.4 0.6-0.7 1.4-0.7 2.4z m9.5 17.9c0-1.6-1-2.5-3.9-4.4-0.2 0-0.3-0.1-0.6-0.1-0.5 0-2.5 0.2-3.9 0.6-1.3 0.5-3 1.3-3 3.3 0 2.4 2.5 4 6.2 4 3.2 0 5.2-1.3 5.2-3.5z m12.8-17.7h6.1v2.7h-6.1v6.3h-2.6v-6.3h-6.3v-2.7h6.3v-6.1h2.6v6.1z' })
        )
    );
};

exports.default = IoSocialGoogleplus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-googleplus.js
// module id = 2929
// module chunks = 168707334958949